export type ValueOf<T> = T[keyof T];

/**
 * @deprecated Legacy CPO identifier map. New integrations must use `operatorId`
 * (for CPOs) and `providerId` (for EMSPs) on the entity directly. This enum
 * will not receive new entries — unknown operators map to `UNKNOWN`.
 */
export const CPOs = Object.freeze({
  UNKNOWN: "???",
  YOURFILL: "YFL",
  ENELX: "ENX",
  FREETOX: "F2X",
});

export type CPOsValues = ValueOf<typeof CPOs>;
export type CPOsKeys = keyof typeof CPOs;


export const EMSPs = Object.freeze({
  ENELX: "ENX",
  FREETOX: "F2X",
  TEST: "TST",
});
export type EMSPsValues = ValueOf<typeof EMSPs>;
export type EMSPsKeys = keyof typeof EMSPs;

export enum CpoText {
    ENX = 'EnelX',
    YFL = 'YourFill',
    F2X = 'FreeToX'
}